import { render } from "./EscalationsView.vue?vue&type=template&id=090706d3&scoped=true"
import script from "./EscalationsView.vue?vue&type=script&lang=js"
export * from "./EscalationsView.vue?vue&type=script&lang=js"

import "./EscalationsView.vue?vue&type=style&index=0&id=090706d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-090706d3"]])

export default __exports__